/**
 * @desc 领用单列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.lendMaster.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
